/* eslint-disable */
<template>
  <div class="container">
    <el-row :gutter="10">
      <el-row :gutter="10">
      <el-col :span="10">
        <filter-wrapper :filter-item="{eatery: true, searchBox: true, canteen: true}"></filter-wrapper>
      </el-col>
      <el-col :span="2" :offset="-3">
        <el-button type="primary" @click="getBaseModelList">查询</el-button>
      </el-col>
    </el-row>
  <el-row :gutter="10">
    <el-col :span="12">
      <el-table
        :data="baseModelList"
        style="width: 100%">
        <el-table-column label="结束时间" align="center">
          <template slot-scope="scope">
            {{ tsTodatetime(scope.row.model_ts) }}
          </template>
          </el-table-column>
            <el-table-column label="标准例图" align="center" header-align="center"
                    prop="classImage">
          <template slot-scope="scope">
            <img v-for="dishModel in scope.row.details" :src="dishModel.dish_url" alt="" :key="dishModel.dish_url"
                width="50">
          </template>
        </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="columnProp"
            label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="checkModel(scope.row)">校验</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-col>
    </el-row>
      <el-dialog
        title="请上传测试小图"
        :visible.sync="checkDialogShow"
      width="30%"
      list-type="picture-card"
      :before-close="handleClose(done)">
        <div class="image-item" v-for="image in checkImageIlist" :key="image">
          <img :src="image" alt="" width="100">
        </div>
      <el-upload
        class="upload-demo"
        action=""
        :limit="4"
        :http-request="handleUpload"
        :show-file-list="false"
        multiple>
        <span class="btn">
          <i class="el-icon-plus"></i>
        </span>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelCheck">取 消</el-button>
        <el-button type="primary" @click="goCheckModel">确 定</el-button>
      </span>
    </el-dialog>
    </el-row>
    <el-row :gutter="10">
     <el-col :span="6">1asssssssssssssss0</el-col>
    </el-row>
  </div>
</template>

<script>
import filterWrapper from '_c/filterWrapper';
import {mapMutations, mapState} from 'vuex';
import {apiBaseModelList, apiCheckModel, apigetDetailByModelId} from '../../api';
import util from '../../lib/util';
import aliOssUpload from '../../lib/aliOSSUpload';
import md5 from 'js-md5';

export default {
  // fix: sad asd
  name: 'trainModel',
  components: {
    filterWrapper
  },
  data () {
    return {
      baseModelList: [],
      checkImageIlist: [],
      checkDialogShow: false,
      checkedRow: null
    };
  },
  mounted () {
    this.setSubTitle('训练产出');
    setTimeout(() => {
      this.getBaseModelList();
    }, 100
    );
  },
  methods: {
    ...mapMutations([
      'emitLoading',
      'removeLoading',
      'setSubTitle'
    ]),
    cancelCheck () {
      this.checkImageIlist = [];
      this.checkDialogShow = false;
    },
    async goCheckModel () {
      try {
        // todo
        let res = await apiCheckModel({
          model_uuid: this.checkedRow.model_uuid,
          img_url_list: this.checkImageIlist,
          canteen_id: this.listQuery.canteen.canteen_id
        });
        this.cancelCheck();
      } catch (e) {
        this.cancelCheck();
        console.log(e);
      }
    },
    async handleUpload (options) {
      let file = options.file;
      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);
      fileReader.onload = async (e) => {
        let md5key = md5(e.target.result);
        try {
          let {url} = await aliOssUpload({
            bucket: 'dish-model-test',
            prefix: 'zx-modelcheck-img',
            name: md5key
          }, file);
          this.checkImageIlist.push(url);
        } catch (e) {
          console.log(e);
          this.$message.error('上传图片到到里云失败');
        }
      };
    },
    handleClose () {

    },
    checkModel (row) {
      this.checkedRow = row;
      this.checkDialogShow = true;
    },
    getBaseModelList () {
      this.emitLoading();
      apiBaseModelList({
        api_key: this.api_key,
        canteen_id: this.listQuery.canteen.canteen_id
      }).then(data => {
        this.removeLoading();
        if (data.state_code === 0) {
          this.baseModelList = data.data.model_list;
          return data.data.model_list;
        } else {
          this.baseModelList = [];
          return Promise.reject(new Error('查询不到基础模型'));
        }
      }).then(modelList => {
        return modelList.map(model =>
          apigetDetailByModelId(model.model_uuid).then(data => {
            if (data.state_code === 0) {
              return Promise.resolve(data.data.dish_info_list);
            } else {
              return Promise.resolve([]);
            }
          })
        );
      }).then(promiseList => {
        let that = this;
        Promise.all(promiseList).then(infos => {
          infos.forEach((info, index) => {
            that.$set(that.baseModelList[index], 'details', info);
          });
        });
      }).catch(e => {
        this.removeLoading();
        console.log(e);
      });
    },
    tsTodatetime (ts) {
      return util.formatTime(ts);
    }
  },
  computed: {
    api_key () {
      return this.$store.getters.userinfo().api_key;
    },
    // 对baseModel进行处理
    formateBaseModelList () {
      // eslint-disable-next-line
      return this.baseModelList.sort((a, b) => b.model_ts - a.model_ts)
    },
    ...mapState({
      listQuery (state) {
        return state.filterWrapper.listQuery;
      }
    })
  },
  watch: {
    listQuery: {
      handler () {
        this.getBaseModelList();
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  .upload-demo {
    display: inline-block;
    width: 100px;
    height: 100px;
    font-size: 50px;
    color: #409eff;
    line-height: 100px;
    text-align: center;
  }
  .image-item {
    display: inline-block;
  }
}
</style>
